import dynamic from 'next/dynamic'
import { useEffect } from 'react'

import useBootstrapData from '@/hooks/useBootstrapData'
import useSeti from '@/hooks/useSeti'
import analytics from '@/shared-utils/analytics'

const HotelsDesktop = dynamic(() => import('./HotelsDesktop'))
const HotelsMobile = dynamic(() => import('./HotelsMobile'))

export default function Hotel() {
  useSeti({ experimentCode: 'AA_HOTELS_LP' }) // AA Test: Unconditional firing and no visual changes
  useSeti({ experimentCode: 'CG_DIGIOH_HTL_LANDING' })
  const { isMobile } = useBootstrapData()
  useEffect(() => {
    analytics.fireGA4Event({
      event: 'page_view',
      attributes: {
        page_name: 'landing',
        page_desc: 'hotel',
      },
    })
  }, [])
  return isMobile ? <HotelsMobile /> : <HotelsDesktop />
}
